// extracted by mini-css-extract-plugin
export default {"body":"ConfirmEmailData_body__jguEW","title":"ConfirmEmailData_title__j7-GY","subtitle":"ConfirmEmailData_subtitle__XMcCs"};